import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
// import { LeftNavComponent } from '../shell/left-nav/left-nav.component';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {
  @ViewChild('user') inputEl: ElementRef;
  isOpen: boolean = false;
  margin: any = 'unset';
  width: any;
  username: string;
  currentUser;
  constructor(public router: Router) { }


  ngOnInit() {
    if (JSON.parse(sessionStorage.getItem('currentUser'))) {
      this.username = JSON.parse(sessionStorage.getItem('currentUser')).name;
    }
  }

  isOpened(flag) {
    this.isOpen = flag;
    if (this.isOpen) {
      this.margin = '180px';
      this.width = '83.7%';
    } else {
      this.margin = 'unset';
      this.width = '96%';
    }
  }
  setUser() {
    if (JSON.parse(sessionStorage.getItem('currentUser'))) {
      this.username = JSON.parse(sessionStorage.getItem('currentUser')).name;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shell/shell.component.ts